export default "__VITE_ASSET__f3f443bd__"